import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';
import defaultUserPhoto from '../../../images/default_user.png';

export default class SearchUser extends Component {
  static propTypes = {
    searchAction: PropTypes.func.isRequired,
    onBlurAction: PropTypes.func.isRequired,
    predictionsList: PropTypes.array.isRequired,
    selectedUser: PropTypes.object,
    handleChangeUser: PropTypes.func.isRequired
  };

  static defaultProps = {
    predictionsList: []
  };

  handleInputText = inputValue => {
    if (inputValue) {
      return this._searchAction(inputValue);
    }
  };

  _searchAction = _.debounce(this.props.searchAction, 500);

  _renderOption = option => {
    const { label, userData: { photo_image_url } } = option;
    return (
      <div className='prediction-list-item-wrapper'>
        <div
          style={{ backgroundImage: `url('${photo_image_url || defaultUserPhoto}')` }}
          className='prediction-list-photo'
        />
        <div>
          <p><strong>{label}</strong></p>
        </div>
      </div>
    );
  };

  render () {
    const { predictionsList, onBlurAction, handleChangeUser, selectedUser } = this.props;
    const options = predictionsList.map(user => ({
      value: user.email, // with value equals to user.id (type number) react-select doesn't render options correctly
      label: `${user.first_name} ${user.last_name}`,
      userData: user
    }));
    return (
      <div className='w-100 mb-3'>
        <Select
          required
          onChange={user => handleChangeUser(user)}
          onInputChange={this.handleInputText}
          onBlur={onBlurAction}
          options={options}
          placeholder='Start typing user name or email'
          value={selectedUser}
          optionRenderer={this._renderOption}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ui/SearchUser.js